import React from 'react';
import PropTypes from 'fe-prop-types';
import { StatelessDrawer } from './StatelessDrawer';

const PROP_TYPES = {
  icon: PropTypes.func,
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool,
  offsetY: PropTypes.string,
  drawerWidth: PropTypes.string,
  maxWidth: PropTypes.string,
  overlayOnOpen: PropTypes.bool,
  id: PropTypes.string,
};

class Drawer extends React.Component {
  state = {
    isOpen: this.props.isOpen,
  };

  toggleDrawer = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  render = () => (
    <StatelessDrawer
      {...this.props}
      isOpen={this.state.isOpen}
      onClick={this.toggleDrawer}
    />
  );
}

Drawer.propTypes = PROP_TYPES;

export { Drawer };
